module.exports = __webpack_public_path__ + "img/ftm-violet.704025d7.png";